module.exports = __webpack_public_path__ + "img/logog.30518be7.png";